import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRoute, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { HelperService } from '@shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthRouthGuard implements CanActivate, CanActivateChild {

  constructor(
    private readonly helperSevrice: HelperService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    console.log('🛡️ [AuthGuard] canActivate called for route:', state.url);
    console.log('🛡️ [AuthGuard] Route data:', route.data);
    return this.canActivateChild(route, state);
  }

  public canActivateChild(route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Observable<boolean> {
    console.log('🛡️ [AuthGuard] canActivateChild called');
    console.log('🛡️ [AuthGuard] Current URL from state:', state?.url);
    
    const authInfo = this.helperSevrice.getAuthInfo();
    console.log('🛡️ [AuthGuard] Auth info from helper service:', authInfo);
    
    const authGuard = this.reDirectToLogin(authInfo, state?.url);
    console.log('🛡️ [AuthGuard] Auth guard result:', authGuard);
    
    return of(authGuard);
  }

  private reDirectToLogin(activateGuard: boolean, currentUrl?: string): boolean {
    console.log('🛡️ [AuthGuard] reDirectToLogin called - activateGuard:', activateGuard, 'currentUrl:', currentUrl);
    
    if (activateGuard) {
      console.log('🛡️ [AuthGuard] ✅ User is authenticated, allowing access');
      return true;
    } else {
      console.log('🛡️ [AuthGuard] ❌ User not authenticated, redirecting to login');
      
      // Save the original URL before redirecting to login
      if (currentUrl && currentUrl !== '/auth/signin') {
        console.log('🛡️ [AuthGuard] ✅ SAVING original URL before redirect:', currentUrl);
        this.helperSevrice.originalUrl.set(currentUrl);
        
        // Verify it was saved
        const savedUrl = this.helperSevrice.originalUrl.get();
        console.log('🛡️ [AuthGuard] ✅ VERIFIED saved URL:', savedUrl);
      } else {
        console.log('🛡️ [AuthGuard] ❌ NOT saving URL (excluded or invalid):', currentUrl);
      }
      
      console.log('🛡️ [AuthGuard] Navigating to auth/signin...');
      this.router.navigate(['auth/signin'], { relativeTo: this.activatedRoute });
      return false;
    }
  }

}
